import axios from "@/libs/api.request";
// 获取列表
export const getRole = params => {
  return axios.request({
    url: "/common/role",
    params,
    method: "get"
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/common/role",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/common/role/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/common/role/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/common/role/${id}`,
    method: "DELETE"
  });
};

// 获取权限
export const getRoleAuth = params => {
  return axios.request({
    url: "/authority/roleAuth",
    params,
    method: "get"
  });
};

export const saveRoleAuth = data => {
  return axios.request({
    url: "/authority/roleAuth",
    method: "post",
    data
  });
};

// 获取当前角色用户
export const getRoleUser = id => {
  return axios.request({
    url: "/common/role/getRoleUser/" + id,
    method: "get"
  });
};

export const dataRule = params => {
  return axios.request({
    url: "/common/role/dataRule",
    params,
    method: "get"
  });
};